import { useEffect, useState } from 'react'

import { getBaseState, transformEventDataToFormState } from '../helpers'

const getClassBaseState = (t) => ({
  building: null,
  eventType: null,
  trainer: null,
  eventName: '',
  description: '',
  location: '',
  repeatable: false,
  eventCapacity: 1,
  askForPostEventReview: false,
  setupAutomatedReminders: false,
  rsvpd: false,
  rsvpdTime: null,
  nonRsvpd: false,
  nonRsvpdTime: null,
  positiveReviewFollowup: false,
  socialLinkService: null,
  schedulerType: { value: 'none', label: t('create-event:helpers.frequencyOptions.doesNotRepeat') },
  image: undefined,
  imagesDatabaseOpen: false,
})

export const useGetClassFormState = (eventData, editMode, buildingId, buildingOptions, t) => {
  const [formState, setFormState] = useState(() =>
    editMode ? transformEventDataToFormState(eventData) : getBaseState(getClassBaseState(t)),
  )
  const { building } = formState

  useEffect(() => {
    if (!building && buildingId) {
      setFormState((prev) => ({
        ...prev,
        building: buildingOptions.find((buildingToFind) => buildingToFind.id === buildingId),
      }))
    }
  }, [buildingOptions, buildingId, building])

  return [formState, setFormState]
}
